import { getTimeText } from '@/utils/event.js';
import { IonDatetime } from '@ionic/react';
import {
  Popover,
  PopoverTrigger,
  Button,
  PopoverContent,
  Input,
} from "@heroui/react";
import { memo } from 'react';
import isEqual from 'react-fast-compare';

const MoneyInput = memo(
  ({
    value,
    onChange,
  }: {
    value: string;
    onChange: (payload: string) => void;
  }) => {
    return (
      <Popover>
        <PopoverTrigger>
          <Button
            variant='bordered'
            radius='full'
            size='sm'
            className='border-1 border-gray-200 font-[500] text-gray-600 h-7'
            startContent={
              <i className='ic-outline md-attach_money scale-105 -mr-1 opacity-60' />
            }
          >
            {value || '添加价格'}
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <div className='  w-80 -mx-1 rounded-2xl pb-2 '>
            <b className='text-xl block px-3 py-3'>设置价格</b>

            <div className='flex items-center justify-between p-2'>
              <Input value={value} onValueChange={onChange} />
            </div>
          </div>
        </PopoverContent>
      </Popover>
    );
  },
  isEqual
);

export default MoneyInput;
